(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin-data/selectors/assets/javascripts/edit-user.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin-data/selectors/assets/javascripts/edit-user.js');
"use strict";


const selectEditUserError = state => state.EditUser && state.EditUser.error;
setGlobal('svs.components.marketplaceRetailAdminData.selectors.editUser', {
  selectEditUserError
});

 })(window);